/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Age_LabelInputs */

const th_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รุ่นอายุ`)
};

const en_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age group`)
};

const ja_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齢区分`)
};

const zh_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年龄组`)
};

const es_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría de edad`)
};

const pt_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria de idade`)
};

const id_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelompok usia`)
};

const fr_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie d’âge`)
};

const tl_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangkat-edad`)
};

const vi_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhóm tuổi`)
};

const ko_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연령대`)
};

const de_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altersklasse`)
};

const ru_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возрастная группа`)
};

const tr_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaş grubu`)
};

const it_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fascia d'età`)
};

const pl_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategoria wiekowa`)
};

const uk_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вікова група`)
};

const hi_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयु वर्ग`)
};

const ar_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئة العمرية`)
};

const ms_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kumpulan umur`)
};

const bn_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বয়সভিত্তিক শ্রেণি`)
};

const zh_tw2_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齡組`)
};

const zh_hk2_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齡組`)
};

const ur_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عمر گروپ`)
};

const fa_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ردهٔ سنی`)
};

const sw_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kundi la umri`)
};

const nl_team_age_label = /** @type {(inputs: Team_Age_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeftijdsgroep`)
};

/**
* | output |
* | --- |
* | "Age group" |
*
* @param {Team_Age_LabelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const team_age_label = /** @type {((inputs?: Team_Age_LabelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Age_LabelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_team_age_label(inputs)
	if (locale === "ja") return ja_team_age_label(inputs)
	if (locale === "zh") return zh_team_age_label(inputs)
	if (locale === "es") return es_team_age_label(inputs)
	if (locale === "pt") return pt_team_age_label(inputs)
	if (locale === "id") return id_team_age_label(inputs)
	if (locale === "fr") return fr_team_age_label(inputs)
	if (locale === "tl") return tl_team_age_label(inputs)
	if (locale === "vi") return vi_team_age_label(inputs)
	if (locale === "ko") return ko_team_age_label(inputs)
	if (locale === "de") return de_team_age_label(inputs)
	if (locale === "ru") return ru_team_age_label(inputs)
	if (locale === "tr") return tr_team_age_label(inputs)
	if (locale === "it") return it_team_age_label(inputs)
	if (locale === "pl") return pl_team_age_label(inputs)
	if (locale === "uk") return uk_team_age_label(inputs)
	if (locale === "hi") return hi_team_age_label(inputs)
	if (locale === "ar") return ar_team_age_label(inputs)
	if (locale === "ms") return ms_team_age_label(inputs)
	if (locale === "bn") return bn_team_age_label(inputs)
	if (locale === "zh-TW") return zh_tw2_team_age_label(inputs)
	if (locale === "zh-HK") return zh_hk2_team_age_label(inputs)
	if (locale === "ur") return ur_team_age_label(inputs)
	if (locale === "fa") return fa_team_age_label(inputs)
	if (locale === "sw") return sw_team_age_label(inputs)
	if (locale === "nl") return nl_team_age_label(inputs)
	return en_team_age_label(inputs)
});